<!-- <div class="main-area">
    <router-outlet></router-outlet>
</div> -->

<div class="flex flex-col min-h-screen">
    <div class="main-area flex-grow">
        <router-outlet />
    </div>
</div>
<app-footer></app-footer>